/* eslint-disable class-methods-use-this */
import env from '@/utils/env';
import Native from '@/utils/nativeProxy';
import alipay from '@/utils/platformUtils/alipay';
import MainStore from '@/store/userStore';
import appConst from '@/const/app.const';
// import { UBT } from '@hb/tianqi';
import router from '../router';

const { UBT } = window.TianQi;

class TIANQI_UBT {
  /**
   * main.js中调用，初始化/切换环境会重新调用一次
   * @returns {Promise<void>}
   */
  async initConfig() {
    // eslint-disable-next-line no-console
    console.log('config传入的env', appConst);
    UBT.config({
      env: appConst.env,
      debug: appConst.env !== 'pro', // 详情 6.1.1
      categoryId: 'hitch', // 详情 6.1.2（v1.2）
      urlHelper: {
        vueRouter: router,
      },
    });
    if (env.isAliMP) {
      await alipay.loadMPJSSDKScript();
    }
    await this.getUserInfo();
    await this.bindData();
  }

  async getUserInfo() {
    try {
      if (env.isEasyBikeApp || env.isHitchIndepApp) {
        const userInfo = await Native.getTokenAndKey({ needLogin: false });
        const locaInfo = await Native.getCityInfo();
        MainStore.setUserInfo({
          userGuid: userInfo.userGuid,
          longitude: locaInfo.lng || locaInfo.longitude,
          latitude: locaInfo.lat || locaInfo.latitude,
          cityCode: locaInfo.citycode || locaInfo.cityCode,
          adCode: locaInfo.adcode || locaInfo.adCode,
          cityName: locaInfo.cityname || locaInfo.cityName || locaInfo.city,
        });
      } else if (env.isAliMP) {
        const { guid: userGuid } = await alipay.mpPostMessage({
          command: 'getUserInfo',
          callbackId: 'getUserInfo',
          dataArray: [{}],
        });
        const getCityInfoByLocationData = await alipay.mpPostMessage({
          command: 'getCityInfoByLocation',
          callbackId: 'getCityInfoByLocation',
          dataArray: [{}],
        });
        const getLocationData = await alipay.mpPostMessage({
          command: 'getLocation',
          callbackId: 'getLocation',
          dataArray: [{}],
        });
        const {
          latitude,
          longitude,
          locateFailMsg,
        } = getLocationData;
        const addressComponent = getCityInfoByLocationData.addressComponent || {};
        const {
          adcode: adCode,
          citycode: cityCode,
        } = addressComponent;
        MainStore.setUserInfo({
          userGuid,
          longitude: (locateFailMsg ? '' : longitude),
          latitude: (locateFailMsg ? '' : latitude),
          cityCode: (locateFailMsg ? '' : cityCode),
          adCode: (locateFailMsg ? '' : adCode),
        });
      } else {
        const userInfo = await Native.getTokenAndKey({ needLogin: false });
        MainStore.setUserInfo({
          userGuid: userInfo.userGuid || '',
          longitude: userInfo.longitude || '',
          latitude: userInfo.latitude || '',
          cityCode: userInfo.cityCode || '',
          adCode: userInfo.adCode || '',
        });
      }
    } catch (e) {
      MainStore.setUserInfo({
        userGuid: '',
        longitude: '',
        latitude: '',
        cityCode: '',
        adCode: '',
      });
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }

  async bindData() {
    const {
      userGuid = '', longitude = '', latitude = '', cityCode = '', adCode = '', cityName = '',
    } = MainStore.getUserStore() || {};
    UBT.bindData({
      appVersion: env.appVersion,
      appName: 'AppHitchMainH5',
      userGuid: () => userGuid,
      longitude: () => longitude,
      latitude: () => latitude,
      cityCode: () => cityCode,
      adCode: () => adCode,
      cityName: () => cityName,
    });
  }

  /**
   * 0320已启用ubtPlugin，后续直接使用this.$pageView等方法
   * 参数参考 @/plugin/ubt.js pageView
   * @deprecated
   * @param params
   * @returns {Promise<void>}
   */
  async pageView(params) {
    UBT.pageView(params);
  }

  /**
   * 参数参考 @/plugin/ubt.js clickButton
   * @deprecated
   */
  async clickButton(params) {
    UBT.clickButton(params);
  }

  /**
   * 参数参考 @/plugin/ubt.js pageViewOut
   * @deprecated
   */
  async pageViewOut(params) {
    UBT.pageViewOut(params);
  }

  /**
   * 参数参考 @/plugin/ubt.js moduleExpose
   * @deprecated
   */
  async moduleExpose(params) {
    UBT.moduleExpose(params);
  }

  /**
   * 参数参考 @/plugin/ubt.js customEvent
   * @deprecated
   */
  async customEvent(params) {
    try {
      const { eventId, ...args } = params;
      this.customEventWithPointId({
        pointId: eventId,
        businessInfo: {
          ...args,
        },
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('customEvent error', e);
    }
  }

  async customEventWithPointId(params) {
    UBT.customEventWithPointId(params);
  }

  updateData(params) {
    UBT.bindData({
      ...params,
    });
  }
}
export default new TIANQI_UBT();
